module.exports = __webpack_public_path__ + "media/KikiF.c5c82c3e.mp3";